import React from "react";
import Table from "react-bootstrap/Table";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import '../../../styles/table.scss'
import {FormControl} from "react-bootstrap";
import {parametresIcon, trashIcon} from "../../icons";
import {ENDPOINT} from "../../../config/config";
import DeleteCommunaute from "./DeleteIndividu";
import setVisibilityIndividu from "./SetVisibilityIndividu";


function TablIndividu({individusList, setIndividusList}: any) {
    const [modalShow, setModalShow] = React.useState(false);
    const [tobedelete, setToBeDelete] = React.useState();
    return (
        <div className="TablIndividu">
            <InputGroup className="mb-3">
                <FormControl
                    placeholder="Search..."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                />
            </InputGroup>
            <Table responsive="sm">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Edit</th>
                    <th>Visibility</th>
                    <th>Delete</th>
                </tr>
                </thead>

                <tbody>
                {individusList.map((e: any, i: number) => (
                        <TablIndividuLine
                            key={e.id}
                            i={i + 1}
                            id={e.id}
                            prenom={e.prenom}
                            visible={e.visible}
                            individusList={individusList}
                            setIndividusList={setIndividusList}
                            setToBeDelete={setToBeDelete}
                            setModalShow={setModalShow}
                        />
                    )
                )}
                </tbody>
            </Table>
            <DeleteCommunaute
                show={modalShow}
                onHide={() => setModalShow(false)}
                tobedelete={tobedelete}
            />

        </div>
    )
}

function TablIndividuLine({
                                i,
                                id,
                                prenom,
                                visible,
                                individusList,
                                setIndividusList,
                                setToBeDelete,
                                setModalShow
                            }: any) {
    return (
        <tr className="TablIndividuLine">
            <td>{i}</td>
            <td>{prenom}</td>
            <td>
                <button className="edit"
                >{parametresIcon}
                </button>
            </td>
            <td>
                <Form.Check
                    type="switch"
                    id="custom-switch"
                    onChange={() => {
                        setVisibilityIndividu(ENDPOINT, id, visible,new Date().toISOString()).then(
                            () => {
                                setIndividusList(() => {
                                    return individusList.map((e: any) => {
                                        if (e.id === id) {
                                            e.visible = !visible;
                                        }
                                        return e;
                                    });
                                });
                            })
                    }}
                    checked={visible}
                />
            </td>
            <td>
                <Button className="deletebnt" variant="primary"
                        onClick={() => {
                            setModalShow(true);
                            setToBeDelete(id);
                        }}
                > {trashIcon}
                </Button>
            </td>
        </tr>
    )
}


export default TablIndividu